const Layout = () => import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");

const News = () => import(/* webpackChunkName: "Home" */ "../views/news/Index.vue");
export default [
    {
        path: "/news",
        name: "news",
        component: Layout,
        meta: {
            title: "资讯中心",
            titleEn: "Information Center",
        },
        children: [
            {
                path: "",
                component: News,
            },
        ],
    },
];
